module.exports = __webpack_public_path__ + "static/media/clemscholar_black.0069175c.jpg";